import React, { Component } from 'react';
import Button from './Button';

import classNames from '../../utils/classNames';

export class SelectTags extends Component {
  constructor(...props) {
    super(...props);

    this.state = {};

    if (this.props.defaultValue) {
      this.state = JSON.parse(this.props.defaultValue);
    }
  }
  toggle(tag) {
    this.setState(prevState => ({
      [tag]: !prevState[tag]
    }));
  }

  render() {
    const { tags, name, defaultValue } = this.props;

    return (
      <div className="SelectTags">
        {tags.map(tag => (
          <Button
            className={classNames(
              'SelectTags__Tag',
              this.state[tag] && 'SelectTags__Tag--active'
            )}
            key={tag}
            onClick={() => this.toggle(tag)}
          >
            {tag}
          </Button>
        ))}
        <input type="hidden" name={name} value={JSON.stringify(this.state)} />
      </div>
    );
  }
}

export default SelectTags;
